// Pure grid edits (spec D9): every op returns { doc, sel } and never mutates its input.
import { LIMITS } from './doc.js';
const AUTO = () => ({ kind: 'auto' });
export const parseId = (id) => { const m = /^c(\d+)-(\d+)$/.exec(String(id)); return m ? { col: +m[1], row: +m[2] } : null; };
export const exists = (doc, id) => { const p = parseId(id); return !!p && p.col < doc.grid.columns.length && p.row < doc.grid.columns[p.col].cells.length; };
const clone = (doc) => structuredClone(doc);
const guard = (op) => (doc, id, ...rest) => (exists(doc, id) ? op(doc, id, ...rest) : { doc, sel: 'c0-0' });
export const splitCell = guard((doc, id) => {
  const { col, row } = parseId(id);
  if (doc.grid.columns[col].cells.length >= LIMITS.cells) return { doc, sel: id };
  const n = clone(doc); n.grid.columns[col].cells.splice(row + 1, 0, { size: AUTO() });
  return { doc: n, sel: `c${col}-${row + 1}` };
});
export const addColumn = guard((doc, id) => {
  const { col } = parseId(id);
  if (doc.grid.columns.length >= LIMITS.columns) return { doc, sel: id };
  const n = clone(doc); n.grid.columns.splice(col + 1, 0, { size: AUTO(), cells: [{ size: AUTO() }] });
  return { doc: n, sel: `c${col + 1}-0` };
});
export const deleteCell = guard((doc, id) => {
  const { col, row } = parseId(id), cols = doc.grid.columns;
  if (cols[col].cells.length > 1) {
    const n = clone(doc), cells = n.grid.columns[col].cells;
    cells.splice(row, 1);
    const k = Math.min(row, cells.length - 1);          // the next cell now sits at `row`, else the previous
    cells[k].size = AUTO();
    return { doc: n, sel: `c${col}-${k}` };
  }
  if (cols.length === 1) return { doc, sel: id };
  const n = clone(doc); n.grid.columns.splice(col, 1);
  const k = Math.min(col, n.grid.columns.length - 1);
  n.grid.columns[k].size = AUTO();
  return { doc: n, sel: `c${k}-0` };
});
export const setColSize = guard((doc, id, size) => { const { col } = parseId(id); const n = clone(doc); n.grid.columns[col].size = { ...size }; return { doc: n, sel: id }; });
export const setCellSize = guard((doc, id, size) => { const { col, row } = parseId(id); const n = clone(doc); n.grid.columns[col].cells[row].size = { ...size }; return { doc: n, sel: id }; });
